import React, { useEffect, Fragment, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Table,
} from 'antd';
import SellerActions from '@Actions/sellerActions';
import { toISTDate } from '@Apis/constants';
import PaymentOutgoingActions from '@Actions/paymentOutgoingActions';
import ExpenseActions from '@Actions/purchase/expense/expenseActions';
import PropTypes from 'prop-types';
import './style.scss';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3Text from '@Uilib/h3Text';
import Helpers from '@Apis/helpers';

/**
 * @param status
 */
const LinkExpensePayment = ({
  user, getPaymentsOutgoing, paymentOutgoing, MONEY,
  getPaymentsOutgoingLoading, linkExpenseLoading, selectedExpense, callback, linkExpense,
}) => {
  const [payments, setPayments] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);

  useEffect(() => {
    getPaymentsOutgoing(1, 50, Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.EXPENSES, Helpers.permissionTypes.READ).join(','), null, 'PAYMENT_SUCCESS', null, null, null, '', selectedExpense?.customer_id, selectedExpense?.seller_id, true);
  }, []);

  useEffect(() => {
    if (paymentOutgoing?.payments?.filter((record) => (record?.unused_amount) > 0)?.[0]?.payment_id !== payments?.[0]?.payment_id) {
      const newData = paymentOutgoing?.payments?.filter((record) => (record?.unused_amount) > 0)?.map((item) => ({ ...item, payment: 0 }));
      setPayments(newData);
    }
  }, [paymentOutgoing]);

  /**
   *
   */
  const isUserPayingMore = () => {
    const paymentUserPaying = payments?.reduce((acc, curr) => {
      acc += Number(curr?.payment);
      return acc;
    }, 0);

    if (paymentUserPaying <= selectedExpense?.grand_total - selectedExpense?.total_payment_made) {
      return false;
    }
    return true;
  };

  /**
   *
   */
  const handleLinkExpensePayment = () => {
    setFormSubmitted(true);
    if (!isUserPayingMore()) {
      const selectedPayment = payments?.filter(
        (record) => (
          !Number(record?.payment)
          || ((record?.payment <= record?.unused_amount && record?.payment)
            && (Number(record?.payment) <= Number(selectedExpense?.grand_total - selectedExpense?.total_payment_made)))),
      )?.map((payment) => ({
        expense_id: selectedExpense?.expense_id,
        amount: payment.payment,
        payment_id: payment.payment_id,
      }));
      const payload = selectedPayment?.filter((payment) => Number(payment?.amount));
      if (selectedPayment?.length === payments?.length && payload?.length) {
        linkExpense(payload, () => {
          callback();
        });
      }
      setFormSubmitted(false);
    }
  };

  /**
   *
   * @param {*} value
   * @param {*} record
   */
  const handlePaymentChange = (value, record) => {
    const copyPayments = payments?.map((item) => {
      if (item?.payment_id === record?.payment_id) {
        return {
          ...item,
          payment: value,
        };
      }

      return {
        ...item,
      };
    });
    setPayments(copyPayments);
  };

  const maxAmount = () => {
    const unUsedAmount = selectedExpense?.grand_total - selectedExpense?.total_payment_made;
    let currentTotal = 0;
      // eslint-disable-next-line no-unused-expressions, array-callback-return
      payments?.map((item) => {
        currentTotal += Number(item?.payment);
      });
      if (Number(unUsedAmount) > Number(currentTotal)) {
        return false;
      }
      const paymentUserPaying = payments?.reduce((acc, curr) => {
        acc += Number(curr?.payment);
        return acc;
      }, 0);
      if (paymentUserPaying === unUsedAmount) {
        return true;
      }
  };

  /**
   * @param {*} value
   * @param item
   * @param record
   */
  const handleFullPayment = (record) => {
    let amount = 0;
    let currentTotal = 0;
    if (!maxAmount()) {
      // eslint-disable-next-line no-unused-expressions, array-callback-return
      payments?.map((item) => {
        currentTotal += Number(item?.payment);
      });
      if (selectedExpense?.grand_total - selectedExpense?.total_payment_made >= record?.unused_amount) {
        amount = record?.unused_amount;
      } else {
        amount = (Number(selectedExpense?.grand_total) - Number(selectedExpense?.total_payment_made)) - Number(currentTotal) - record?.payment;
      }

      if (amount <= 0) {
        amount = 0;
      }
      const copyPayments = payments?.map((item) => {
        if (item?.payment_id === record?.payment_id) {
          return {
            ...item,
            payment: amount,
          };
        }

        return {
          ...item,
        };
      });
      setPayments(copyPayments);
    }
  };

  /**
   *
   */
  const getTotalAmountSum = () => {
    const paymentUserPaying = payments?.reduce((acc, curr) => {
      acc += Number(curr?.payment);
      return acc;
    }, 0);
    return paymentUserPaying;
  };

  /**
   *
   */
  const getTotalAmountExceed = () => {
    const paymentUserPaying = getTotalAmountSum();
    return (paymentUserPaying - (selectedExpense?.grand_total - selectedExpense?.total_payment_made));
  };

  const column = [
    {
      title: 'DATE',
      render: (record) => toISTDate(record?.payment_date).format('DD/MM/YYYY'),
    },
    {
      title: 'PAYMENT #',
      dataIndex: 'payment_id',
    },
    {
      title: 'REFERENCE #',
      dataIndex: 'utr_number',
    },
    {
      title: 'MODE',
      render: (text, record) => `${record?.account_info?.account_name || 'Cash'}`,
    },
    {
      title: 'AMOUNT',
      dataIndex: 'due_at',
      render: (text, record) => MONEY(record?.amount),
    },
    {
      title: 'UNUSED AMOUNT',
      dataIndex: 'due_at',
      render: (text, record) => MONEY(record?.unused_amount),
    },
    {
      title: 'PAYMENT',
      render: (text, record) => (
        <div className="link-expense-payment-amount-input">
          <input
            type="number"
            min="0"
            // disabled={maxAmount()}
            max={JSON.stringify(record?.unused_amount)}
            value={record?.payment}
            onChange={(e) => { handlePaymentChange(e.target.value, record); }}
          />
          <H3Text
            text={(
              <div>
                Record Full
              </div>
            )}
            onClick={() => handleFullPayment(record)}
            className="link-expense-payment__pay-full"
          />
          {((Number(record?.payment) > Number(record?.unused_amount)) || (Number(record?.payment) > Number(selectedExpense?.grand_total - selectedExpense?.total_payment_made))) && <div className="input-error">Please enter valid amount*</div>}
        </div>
      ),
    },
  ];

  return (
    <Fragment>
      <div className="link-expense-payment__wrapper">
        <Table
          size="small"
          scroll="scroll"
          loading={getPaymentsOutgoingLoading || linkExpenseLoading}
          columns={column}
          dataSource={payments || []}
          pagination={false}
        />
        <div className="link-expense-payment-totals__wrapper">
          <div className="link-expense-payment-totals">
            <div className="grn-total_field">
              <H3Text text="Expense Amount" className="grn-total_field-name" />
              <H3Text text={MONEY(selectedExpense?.grand_total - selectedExpense?.total_payment_made)} className="grn-total_field-value" />
            </div>
            <div className="grn-total_field">
              <H3Text text="Linked Amount" className="grn-total_field-name" />
              <H3Text text={MONEY(getTotalAmountSum() || '0')} className="grn-total_field-value" />
            </div>
            <div className="grn-total_field grn-total_field-total">
              <H3Text text="Pending Amount" className="grn-total_field-name" />
              <H3Text text={MONEY(((selectedExpense?.grand_total - selectedExpense?.total_payment_made) - getTotalAmountSum()) || '0')} className="grn-total_field-value" />
            </div>
            {payments && payments?.length !== 0 && isUserPayingMore() && (
              <H3Text text="*You have entered amount in excess" className="link-expense-payment__error" />
            )}
          </div>
        </div>
        <div className="link-expense-payment__footer">
          <H3Button
            text="Link Payment"
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            onClick={() => {
              if (!linkExpenseLoading) {
                handleLinkExpensePayment();
              }
            }}
            isLoading={linkExpenseLoading}
            disabled={linkExpenseLoading || (payments && payments?.length !== 0 && isUserPayingMore())}
          />
        </div>

      </div>
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, SellerReducers, GRNReducers, PaymentOutgoingReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  sellers: SellerReducers.sellers,
  getGRNLoading: GRNReducers.getGRNLoading,
  grnData: GRNReducers.grnData,
  linkExpenseLoading: PaymentOutgoingReducers.linkExpenseLoading,
  getPaymentsOutgoingLoading: PaymentOutgoingReducers.getPaymentsOutgoingLoading,
  paymentOutgoing: PaymentOutgoingReducers.paymentOutgoing,
});
const mapDispatchToProps = (dispatch) => ({
  getSellers: (keyword, tenantId, page, limit) => dispatch(SellerActions.getSellers(keyword, tenantId, page, limit)),
  getPaymentsOutgoing: (page, limit, tenantId, tenantSellerId, status, tenantRoleId, approvalStatus, paymentType, searchKeyword, customerId, sellerId, isExpense) => dispatch(PaymentOutgoingActions.getPaymentsOutgoing(page, limit, tenantId, tenantSellerId, status, tenantRoleId, approvalStatus, paymentType, searchKeyword, customerId, sellerId, isExpense)),
  getPaymentsOutgoingSuccess: (paymentOutgoing) => dispatch(PaymentOutgoingActions.getPaymentsOutgoingSuccess(paymentOutgoing)),
  linkExpense: (payload, callback) => dispatch(ExpenseActions.linkExpense(payload, callback)),
});

LinkExpensePayment.propTypes = {
  linkExpenseLoading: PropTypes.bool,
  getPaymentsOutgoingLoading: PropTypes.bool,
  getPaymentsOutgoing: PropTypes.func,
  linkExpense: PropTypes.func,
  callback: PropTypes.func,
  paymentOutgoing: PropTypes.any,
  selectedExpense: PropTypes.any,
  user: PropTypes.any,
  getPaymentsOutgoingSuccess: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LinkExpensePayment));
